import React from 'react';
import { useTranslation } from 'react-i18next';

import { CustomerListMappingValue } from '~/utils/customerListMatchingRules';

import { FieldLabel } from '../visitiqCatalog.styles';
import { FieldContainer, OrSeparator, RuleCard, RuleHeader } from './MatchingRulesField.styles';
import ProfileOnlyWarning from './ProfileOnlyWarning';
import RuleTitle from './RuleTitle';

interface RulesDisplayProps {
  label?: string;
  value: CustomerListMappingValue;
}

/**
 * The submitted rules, read-only, as the confirmation card shows them: "or" between rules, each rule on one line with
 * every column's type: "All of a as Email + b as ZIP" for several columns.
 */
const RulesDisplay = ({ label, value }: RulesDisplayProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <FieldContainer>
      {label && <FieldLabel>{label}</FieldLabel>}
      {value.rules.map((fields, ruleIndex) => {
        const isProfileOnly = !fields.some(([, , attribute]) => value.identifierAttributes.includes(attribute));
        return (
          <React.Fragment key={fields.map(([index]) => index).join('-')}>
            {ruleIndex > 0 && <OrSeparator>{t('aiInsights.a2ui.matchingRules.or')}</OrSeparator>}
            <RuleCard>
              <RuleHeader>
                <RuleTitle fields={fields} />
              </RuleHeader>
              {isProfileOnly && <ProfileOnlyWarning />}
            </RuleCard>
          </React.Fragment>
        );
      })}
    </FieldContainer>
  );
};

export default RulesDisplay;
